import React from "react";
import Button from "@material-ui/core/Button";
import Paper from "@material-ui/core/Paper";

// 加工指示の追加ダイアログ・グループ操作ダイアログの描画をまとめる。
// 本文は HinbanMaster.js から移設したもの。

export function createKakousijiDialogRenderer(deps) {
    const {
        DicVal,
        closeKakousijiAddDialog,
        closeKakousijiGroupDialog,
        commitKakousijiAddDialog,
        commitKakousijiGroupDialog,
        isEmpty,
        kakousijiAddDialogState,
        kakousijiGroupDialogState,
        kakousijiGroupNoToLabel,
        setKakousijiAddDialogState,
        setKakousijiGroupDialogState,
        updateKakousijiGroupDialogColorChecked
    } = deps;

    function renderKakousijiAddDialog() {
        if (!kakousijiAddDialogState.open) return null;

        const options = Array.isArray(kakousijiAddDialogState.options)
            ? kakousijiAddDialogState.options
            : [];

        const currentIndex = Math.max(0, options.findIndex((item) =>
            String(DicVal(item, "code", "")).trim() === String(kakousijiAddDialogState.selectedValue ?? "").trim()
        ));
        const currentItem = options[currentIndex] || null;

        const moveSpin = (step) => {
            if (kakousijiAddDialogState.busy) return;
            if (options.length === 0) return;
            const nextIndex = (currentIndex + step + options.length) % options.length;
            setKakousijiAddDialogState((prev) => ({
                ...prev,
                selectedValue: String(DicVal(options[nextIndex], "code", "")).trim()
            }));
        };


        return (
            <div className="hinban-dialog-overlay" onClick={closeKakousijiAddDialog}>
                <Paper elevation={3} className="hinban-dialog-paper hinban-dialog-paper--add" onClick={(e) => e.stopPropagation()}>
                    <div className="hinban-dialog-title">
                        加工指示区分選択
                    </div>

                    <div className="hinban-add-dialog-field">
                        <div className="hinban-add-dialog-label">加工指示区分</div>

                        <div className="hinban-add-dialog-code">
                            {isEmpty(currentItem) ? "" : String(DicVal(currentItem, "code", ""))}
                        </div>

                        <div className="hinban-add-dialog-name">
                            {isEmpty(currentItem) ? "" : String(DicVal(currentItem, "name", ""))}
                        </div>

                        <div className="hinban-add-dialog-spinner">
                            <button
                                type="button"
                                onClick={() => moveSpin(-1)}
                                disabled={kakousijiAddDialogState.busy || options.length === 0}
                                className="hinban-add-dialog-spinner-button"
                            >
                                ▲
                            </button>
                            <button
                                type="button"
                                onClick={() => moveSpin(1)}
                                disabled={kakousijiAddDialogState.busy || options.length === 0}
                                className="hinban-add-dialog-spinner-button"
                            >
                                ▼
                            </button>
                        </div>
                    </div>

                    <div className="hinban-dialog-footer">
                        <Button
                            type="button"
                            size="small"
                            variant="contained"
                            onClick={closeKakousijiAddDialog}
                            disabled={kakousijiAddDialogState.busy}
                        >
                            Cancel
                        </Button>
                        <Button
                            type="button"
                            size="small"
                            variant="contained"
                            color="primary"
                            onClick={commitKakousijiAddDialog}
                            disabled={kakousijiAddDialogState.busy || isEmpty(currentItem)}
                        >
                            実行
                        </Button>
                    </div>
                </Paper>
            </div>
        );
    }
    function renderKakousijiGroupActionDialog() {
        if (!kakousijiGroupDialogState.open) return null;
        const isAdd = kakousijiGroupDialogState.mode === 'add';
        const isDelete = kakousijiGroupDialogState.mode === 'delete';
        const colorOptions = Array.isArray(kakousijiGroupDialogState.colorOptions) ? kakousijiGroupDialogState.colorOptions : [];
        const title = kakousijiGroupDialogState.title || 'グループ操作';
        const groupLabel = kakousijiGroupNoToLabel(kakousijiGroupDialogState.groupNo) || kakousijiGroupDialogState.groupNo || '';
        return (
            <div className="hinban-dialog-overlay" onClick={closeKakousijiGroupDialog}>
                <Paper elevation={3} className="hinban-dialog-paper hinban-dialog-paper--group" onClick={(e) => e.stopPropagation()}>
                    <div className="hinban-group-dialog-title">{title}</div>
                    {isDelete ? null : (
                        <div className="hinban-group-dialog-row">
                            <span className="hinban-group-dialog-label">Group</span>
                            <input
                                type='text'
                                value={isAdd ? kakousijiGroupDialogState.groupNo : groupLabel}
                                readOnly={!isAdd}
                                maxLength={2}
                                onChange={(e) => {
                                    const value = String(e.target.value ?? '').replace(/[^\d]/g, '').slice(0, 2);
                                    setKakousijiGroupDialogState((prev) => ({ ...prev, groupNo: value }));
                                }}
                                className="hinban-group-dialog-input"
                            />
                        </div>
                    )}
                    {isDelete ? (
                        <div className="hinban-group-dialog-message">Delete the currently selected group rows?</div>
                    ) : (
                        <div className="hinban-group-dialog-table-wrap">
                            <table className="hinban-group-dialog-table">
                                <thead>
                                    <tr>
                                        <th className="hinban-group-dialog-th hinban-group-dialog-col--check">{'選択'}</th>
                                        <th className="hinban-group-dialog-th hinban-group-dialog-col--code">{'カラー'}</th>
                                        <th className="hinban-group-dialog-th">{'カラー名'}</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {colorOptions.length === 0 ? (
                                        <tr><td colSpan={3} className="hinban-group-dialog-td"></td></tr>
                                    ) : colorOptions.map((item) => (
                                        <tr key={DicVal(item, 'colorCd', '')}>
                                            <td className="hinban-group-dialog-td hinban-group-dialog-col--check"><input type='checkbox' checked={!!DicVal(item, 'checked', false)} onChange={(e) => updateKakousijiGroupDialogColorChecked(DicVal(item, 'colorCd', ''), e.target.checked)} /></td>
                                            <td className="hinban-group-dialog-td hinban-group-dialog-col--code">{DicVal(item, 'colorCd', '')}</td>
                                            <td className="hinban-group-dialog-td">{DicVal(item, 'colorName', '')}</td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    )}
                    <div className="hinban-dialog-footer">
                        <Button type='button' size='small' variant='contained' onClick={closeKakousijiGroupDialog} className="hinban-dialog-cancel-button">Cancel</Button>
                        <Button type='button' size='small' variant='contained' onClick={commitKakousijiGroupDialog} className="hinban-dialog-run-button">{'実行'}</Button>
                    </div>
                </Paper>
            </div>
        );
    }

    return {
        renderKakousijiAddDialog,
        renderKakousijiGroupActionDialog
    };
}
